import React from 'react';
import { useSelector } from 'react-redux';

import BarChart from 'components/BarChart';
import { getPds } from 'store/scenes/distributions/pds/selectors';

import {
  getTailType,
  isLeftTailSelected,
  isRightTailSelected,
  isEqualTailSelected
} from 'store/scenes/distributions/chart/selectors';

import { getBRightCutoff, getBLeftCutoff } from 'store/form/distributions/selectors';

const BarChartContainer = () => {
  const pds = useSelector(state => getPds(state));
  const rightCutoff = useSelector(state => getBRightCutoff(state));
  const leftCutoff = useSelector(state => getBLeftCutoff(state));
  const leftTailSelected = useSelector(state => isLeftTailSelected(state));
  const rightTailSelected = useSelector(state => isRightTailSelected(state));
  const equalTailSelected = useSelector(state => isEqualTailSelected(state));
  const centerTailsSelected = useSelector(state => getTailType(state)) === 'center';

  const getColor = value => {
    const orangeColor = '#ffab00';
    const blueColor = '#119fd6';

    let currentColor = blueColor;

    // for left or right tail
    if ((leftTailSelected && value <= leftCutoff) || (rightTailSelected && value >= leftCutoff)) {
      currentColor = orangeColor;
    }

    // for both tail
    if (leftTailSelected && rightTailSelected) {
      currentColor = blueColor;
      if ((value <= leftCutoff) || (value >= rightCutoff)) {
        currentColor = orangeColor;
      }
    }

    // for between tail
    if (centerTailsSelected) {
      currentColor = blueColor;
      if (value >= leftCutoff && value <= rightCutoff) {
        currentColor = orangeColor;
      }
    }

    // for equal tail
    if (equalTailSelected) {
      if (value === +leftCutoff) {
        currentColor = orangeColor;
      }
    }

    return currentColor;
  };

  const getBars = () => {
    const bars = pds.filter(item => item.y >= 0.0001);
    return bars.map(item => ({ name: item.x, count: item.y, color: getColor(item.x) }));
  };

  return (
    <BarChart
      bars={getBars()}
      xAxisLabel="x"
      yAxisLabel="f(x)"
      isColorGradient={false}
    />
  );
};

export default BarChartContainer;
